<p-dialog
  position="topleft"
  [modal]="true"
  [visible]="!!widget"
  [resizable]="true"
  [closable]="false"
  (onHide)="closeExportDialog()">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-file-export" text="Darstellung exportieren" />
  </ng-template>
  @if (widget) {
    <div
      class="relative p-3 w-full flex flex-column export-container surface-ground border-round">
      <div
        class="surface-0 border-round"
        [ngClass]="{ half: halfPage, portrait: portrait, landscape: !portrait }"
        #exportContainer>
        <app-custom-widget
          [id]="widget._id"
          [export]="true"></app-custom-widget>
        <div class="pt-0 flex gap-4 -mt-4">
          <strong
            ><i class="fas fa-info-circle"></i> {{ widgetCaption }}</strong
          >
          <i class="text-color-secondary"
            ><i class="fas fa-copyright"></i>
            {{ globalsStore.sourceString() }}</i
          >
        </div>
      </div>
    </div>
  }
  <ng-template pTemplate="footer">
    <div class="flex gap-3 align-items-center pt-3">
      <p-button
        [rounded]="true"
        label="abbrechen"
        [text]="true"
        severity="secondary"
        icon="fas fa-xmark"
        (onClick)="closeExportDialog()" />
      <p-toggleButton
        class="ml-auto"
        [style]="{ 'border-radius': '10rem' }"
        [onIcon]="'fas fa-file-half-dashed'"
        [offIcon]="'fas fa-file'"
        [(ngModel)]="halfPage"
        onLabel="halbe Seite"
        offLabel="ganze Seite" />
      <p-toggleButton
        [style]="{ 'border-radius': '10rem' }"
        [onIcon]="'fas fa-file-image'"
        [offIcon]="'fas fa-image'"
        [(ngModel)]="portrait"
        onLabel="Hochformat"
        offLabel="Querformat" />
      <p-button
        [rounded]="true"
        label="konfigurieren"
        [outlined]="true"
        icon="fas fa-cog"
        severity="primary"
        (onClick)="showConfig()" />
      <p-button
        [rounded]="true"
        icon="fas fa-file-export"
        label="exportieren"
        (onClick)="exportWidget()" />
    </div>
  </ng-template>
</p-dialog>
